import { CustomModal } from './CustomModal'
export default CustomModal
export { CustomModal, ModalProps } from './CustomModal'
